var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":{"create":false,"uploadSourceMaps":false}};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/
import * as Sentry from "@sentry/nextjs";
import { initializeSentry } from "./src/utils/sentry-init";

// Initialize Sentry with our utility
initializeSentry();
console.log("Sentry initialized");
console.log(
	"process.env.NEXT_PUBLIC_DEPLOY_ENV:",
	process.env.NEXT_PUBLIC_DEPLOY_ENV,
);
console.log("process.env.NODE_ENV:", process.env.NODE_ENV);
Sentry.init({
	dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,

	// Adjust this value in production, or use tracesSampler for greater control
	tracesSampleRate: 1.0,

	// Setting this option to true will print useful information to the console while you're setting up Sentry.
	debug: process.env.NEXT_PUBLIC_DEPLOY_ENV === "development",

	replaysOnErrorSampleRate: 1.0,

	// This sets the sample rate to be 10%. You may want this to be 100% while
	// in development and sample at a lower rate in production
	replaysSessionSampleRate: 0.1,

	environment: process.env.NEXT_PUBLIC_DEPLOY_ENV,

	release: process.env.npm_package_version,

	// You can remove this option if you're not planning to use the Sentry Session Replay feature:
	integrations: [
		new Sentry.BrowserTracing({
			tracePropagationTargets: [
				"localhost",
				"api.flowandgrow.tech",
				"admin.flowandgrow.tech",
			],
		}),
	],

	beforeSend(event) {
		// Don't send events in development
		if (process.env.NEXT_PUBLIC_DEPLOY_ENV === "development") {
			return null;
		}
		return event;
	},

	// Add source map configuration
	attachStacktrace: true,
	enableTracing: true,
});
